// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/news/news.scss
 ** module id = 113
 ** module chunks = 0 1
 **/